import React, { useState } from 'react'
import { Link } from "react-router-dom"

import AlliedBox from '../molecules/AlliedBox'
import { sendDataLayer } from '../../utils/functions'
import Slider from 'react-slick';

function AlliancesGallery({
  alliedBoxType,
  itemsPerLine,
  termsOnModal,
  list,
  termText,
}) {
  const [viewMore, setViewMore] = useState(false);
  const [viewLess, setViewLess] = useState(false);
  const layerTerms = () => {
    sendDataLayer({datalayer: { event: 'alliances', text: 'Conoce detalles y todas las alianzas', link: 'https://www.mastercard.com.co/es-co/consumidores/conozca-nuestras-ofertas-y-promociones/every-day-value.html' },repeat: false})
  }

  const settings = {
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
    dots: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5
        }
      }
    ]
  };

  const view_more_mobile = () => {
    setViewMore(true)
    setViewLess(true)
  }
  const view_less_mobile = () => {
    setViewMore(false)
    setViewLess(false)
  }

  
  

  return (
    <div className={`mc-alliances-container mc-alliances-column-${itemsPerLine}`}>
      
      {list &&
        <div className={`mc-alliances-container__items ${viewMore ? 'show-more' : ''}`}>


          <Slider {...settings}>
            {list.map((item, index) => (
              <div key={index} className={`mc-alliances-container__items--item type-${alliedBoxType}`}>
                <AlliedBox
                  type={alliedBoxType}
                  allied={item}
                  termLink={item.termLink}
                  termText={termText}
                  termsOnModal={termsOnModal}
                  termsData={item.termsData}
                />
              </div>
            ))}
          </Slider>

        </div>
      }

      <div className={`mc-alliances-container__viewmore ${viewMore ? 'show-more' : ''}`} onClick={view_more_mobile}>
        <button>
          <img src="/assets/images/view_more.png" />
        </button>
      </div>
      <div className={`mc-alliances-container__viewless ${viewLess ? 'show-less' : ''}`} onClick={view_less_mobile}>
        <button>
          <img src="/assets/images/view_less.png" />
        </button>
      </div>

      <div className="mc-alliances-container__actions">
        <Link onClick={layerTerms} to="https://www.mastercard.com.co/es-co/consumidores/conozca-nuestras-ofertas-y-promociones/every-day-value.html" target='_blank'>Conoce detalles y todas las alianzas</Link>
      </div>

    </div>
  )
}

export default AlliancesGallery